// BNB
export const DEFAULT_INPUT_CURRENCY = '0x55d398326f99059fF775485246999027B3197955'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0xcb4164DB403369e597D9Bf2659e0DFAf3fD67Ce5'
